
import { Component, Prop, Vue, PropSync } from "vue-property-decorator";

@Component
export default class Header extends Vue {
  @Prop([String]) private value!: string;
  // 初始数据可以直接声明为实例的 property
  @PropSync("phone") formPhone !: string;
}
